const FINANCIAL_DIR = Object.freeze({
  UP: 'up',
  DOWN: 'down',
  RIGHT: 'right',
});
export default Object.freeze({
  FINANCIAL_DIR,
});
export { FINANCIAL_DIR };
